/**
 * Mixin de tela cheia do CodeMirror (addon display/fullscreen), compartilhado
 * por SqlEditor.vue e ncform/Codeblock.vue — a lógica era duplicada nos dois.
 *
 * O componente hospedeiro deve implementar `getCmEditor()` retornando a
 * instância do CodeMirror (ou null enquanto não montada) e importar o addon
 * codemirror/addon/display/fullscreen (js + css).
 */
export default {
  data() {
    return {
      isFullScreen: false,
    };
  },
  methods: {
    // Deve ser sobrescrito pelo componente hospedeiro.
    getCmEditor() {
      return null;
    },
    setFullScreen(on) {
      const editor = this.getCmEditor();
      if (!editor) return;
      editor.setOption("fullScreen", on);
      this.isFullScreen = !!editor.getOption("fullScreen");
      if (this.isFullScreen) {
        // Em tela cheia, o Esc deve fechar APENAS a tela cheia (não o modal).
        // Captura no documento para impedir que o handler de Esc do modal dispare.
        document.addEventListener("keydown", this.onFullScreenKey, true);
        document.addEventListener("keyup", this.onFullScreenKey, true);
        editor.focus();
      } else {
        this.removeFullScreenListeners();
      }
    },
    toggleFullScreen() {
      const editor = this.getCmEditor();
      if (!editor) return;
      this.setFullScreen(!editor.getOption("fullScreen"));
    },
    onFullScreenKey(e) {
      if (e.key !== "Escape") return;
      // Bloqueia o Esc para o CodeMirror e para o modal; sai da tela cheia no keyup.
      e.preventDefault();
      e.stopImmediatePropagation();
      if (e.type === "keyup") {
        this.setFullScreen(false);
      }
    },
    removeFullScreenListeners() {
      document.removeEventListener("keydown", this.onFullScreenKey, true);
      document.removeEventListener("keyup", this.onFullScreenKey, true);
    },
  },
  beforeDestroy() {
    this.removeFullScreenListeners();
  },
};
